/**
 * @desc 请求报告记录分页查询
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.platDataFlow.reportPage.requestRecordPage.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/reportPage/requestRecordPage`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
